<template>
  <div :class="classList">
    <label>{{ label }}</label>
    <div
      class="row placement-time-row"
      v-for="(workday, index) of listDays"
      :key="index"
    >
      <div class="col-md-2 day-checkbox-container">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="listDayCheck[index]"
            @change="handleDataChange()"
            :id="'workday' + index"
          />
        </div>
        <label class="workday-label" :for="'workday' + index">{{
          workday
        }}</label>
      </div>
      <TimePickerWithLabel
        label="From"
        v-model="listFrom[index]"
        classList="col-md-5 time-from-container"
        :isDisabled="listDayCheck[index] !== true"
        :submitClicked="submitClicked"
        @input="handleDataChange()"
      />
      <TimePickerWithLabel
        label="To"
        classList="col-md-5 time-to-container"
        v-model="listTo[index]"
        :isDisabled="listDayCheck[index] !== true"
        :submitClicked="submitClicked"
        @input="handleDataChange()"
      />
    </div>
    <p
      class="required-message"
      v-if="!listDayCheck.includes(true) && submitClicked && isRequired"
    >
      This field is required.
    </p>
  </div>
</template>
<script>
/* This component is used to select working hours (from ... to ...) for each working day (From Monday to Friday)*/
import TimePickerWithLabel from "./TimePickerWithLabel";

export default {
  name: "DayHoursSelector",
  components: {
    TimePickerWithLabel
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: Array,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // true if disable the timepicker
    listDays: Array
  },
  data() {
    return {
      listDayCheck: this.getListDayCheck(),
      listFrom: this.getListFrom(),
      listTo: this.getListTo()
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", this.dateInDjangoFormat(val));
      }
    }
  },
  methods: {
    getListDayCheck() {
      if (this.value == null || this.value.length === 0) {
        return [];
      }
      const listDayCheck = [];
      for (const val of this.value) {
        if (val == null || val === "") {
          listDayCheck.push(null);
        } else {
          listDayCheck.push(true);
        }
      }
      return listDayCheck;
    },
    getListFrom() {
      if (this.value == null || this.value.length === 0) {
        return [];
      }
      const listFrom = [];
      for (const val of this.value) {
        if (val == null) {
          listFrom.push(null);
        } else {
          const fromToTokens = val.split(",");
          const fromToken = fromToTokens[0].split(":");
          if (fromToken.length != 2) {
            listFrom.push(null);
          } else {
            listFrom.push({ HH: fromToken[0], mm: fromToken[1] });
          }
        }
      }
      return listFrom;
    },
    getListTo() {
      if (this.value == null || this.value.length === 0) {
        return [];
      }
      const listTo = [];
      for (const val of this.value) {
        if (val == null) {
          listTo.push(null);
        } else {
          const fromToTokens = val.split(",");
          if (fromToTokens.length < 2) {
            listTo.push(null);
            continue;
          }
          const toToken = fromToTokens[1].split(":");
          if (toToken.length != 2) {
            listTo.push(null);
          } else {
            listTo.push({ HH: toToken[0], mm: toToken[1] });
          }
        }
      }
      return listTo;
    },
    handleDataChange() {
      let result = [];
      for (let index = 0; index < this.listDays.length; index++) {
        const dayCheck = this.listDayCheck[index];
        if (dayCheck !== true) {
          result.push("");
          continue;
        }
        let fromTo = "";
        const from = this.listFrom[index];
        if (from != null) {
          fromTo += from.HH + ":" + from.mm;
        }
        fromTo = fromTo + ",";
        const to = this.listTo[index];
        if (to != null) {
          fromTo += to.HH + ":" + to.mm;
        }
        result.push(fromTo);
      }
      this.$emit("input", result);
    }
  }
};
</script>

<style scoped>
.day-checkbox-container {
  display: flex;
  align-items: center;
}

.day-checkbox-container .form-check-input {
  margin-top: 0;
}

.workday-label {
  margin-bottom: 0.5em;
}

@media only screen and (min-width: 768px) {
  .time-from-container,
  .time-to-container {
    padding-left: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/DayHoursSelector.vue